/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
import React, { useState, useEffect } from 'react'
import Hls from 'hls.js'
import { Element, Column } from 'trux'
import { apiFolder } from '../../util/apiFolder'

import './PreviewVideo.css'

export const PreviewVideo = (props) => {
    let [loadingVideoUrl, setLoadingVideoUrl] = useState(null)
	let nhls = null
	let start = props.start
	let end = props.end

    const loadVideo = (moment, teamName, gameId) => {
        var video = document.getElementById('preview-video')
        video.volume = 0

        let hlsUrl = ''
        if (props.game && props.moment) {
            hlsUrl = apiFolder(props.game) + '/teams/' + teamName + '/games/' + teamName + '-' + gameId + '/' + moment.dynamic.hls
        }
        let nativeHls = video.canPlayType && !!video.canPlayType('application/vnd.apple.mpegURL')

        // Make sure we just load once
        if (loadingVideoUrl === hlsUrl) {
            return
        }
        setLoadingVideoUrl(hlsUrl)

        if (Hls.isSupported()) {
            nhls = new Hls()
            nhls.loadSource(hlsUrl)
            nhls.attachMedia(video)
            nhls.on(Hls.Events.MANIFEST_PARSED, () => {
                videoReady()
            })
        } else if (nativeHls) {
            video.setAttribute('src', hlsUrl)
            video.load()
            video.addEventListener('canplay', videoReady)
        }

		console.log("loading Video")
    }

    const videoReady = () => {
        let video = document.getElementById('preview-video')
        video.removeEventListener('canplay', videoReady)

        video.currentTime = props.start ? props.start : 0
        video.loop = true
        try {
            video.play()
        } catch (e) {
            // nothing to do
        }
    }

    const onGoTo = (e) => {
        let time = e.detail.time
        let video = document.getElementById('preview-video')
		console.log("onGoTo", time)
        video.currentTime = time
    }

    const playEvent = (e) => {
        let video = document.getElementById('preview-video')
        video.play()
    }

    const pauseEvent = (e) => {
        let video = document.getElementById('preview-video')
        video.pause()
    }

    let tickId = null
    const tick = () => {
        if (tickId) {
            clearTimeout(tickId)
            tickId = null
        }
        let video = document.getElementById('preview-video')
		if (!video) {
			return 
		}
        if (props.start) {
            if (video.currentTime < props.start) {
                video.currentTime = props.start
            }
        }
        if (props.end) {
            if (video.currentTime > props.end) {
                video.currentTime = props.start ? props.start : 0
            }
        }
        if (props.onVideoUpdate && !video.paused) {
            props.onVideoUpdate(video.currentTime)
        }
        tickId = setTimeout(tick, 1000/4)
    }

	let moment = props.moment
	let teamName = props.teamName
	let gameId = props.gameId

	useEffect(() => {
        tick()

        return () => {
            if (tickId) {
                clearInterval(tickId)
            }
        }
    }, [start, end, tick, tickId])

    useEffect(() => {
        loadVideo(moment, teamName, gameId)
        document.addEventListener('preview-video-goto', onGoTo)
        document.addEventListener('preview-video-pause', pauseEvent)
        document.addEventListener('preview-video-play', playEvent)

        return () => {
			if (nhls) {
				nhls.destroy()
			}
            document.removeEventListener('preview-video-goto', onGoTo)
            document.removeEventListener('preview-video-play', playEvent)
            document.removeEventListener('preview-video-pause', pauseEvent)
        }
    }, [moment, teamName, gameId, nhls])

    let attr = {
        ...props,
        moment: null,
        teamName: null,
        gameId: null,
        className: 'PreviewVideo',
        onVideoUpdate: null,
    }

    return (
        <Element {...attr}>
            <Column center>
                <video id="preview-video" playsInline />
            </Column>
        </Element>
    )
}
